import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { DynamicQuestionnaire } from 'benchmarking-domain/dynamic-questionnaire';
import { enqueueSnackbar } from 'notistack';

export interface DynamicQuestionnaireCreateFormProps {
  dynamicQuestionnaireDetails?: { dynamicQuestionnaire?: DynamicQuestionnaire; maxOccurrence?: number };
  onSubmit: (dynamicItemName: string) => Promise<{ errorMessage?: string }>;
}

export default function DynamicQuestionnaireCreateForm({
  dynamicQuestionnaireDetails,
  onSubmit,
}: DynamicQuestionnaireCreateFormProps) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!dynamicQuestionnaireDetails || !dynamicQuestionnaireDetails.dynamicQuestionnaire) {
    return null;
  }

  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen} sx={{ width: 'fit-content' }}>
        Add new {dynamicQuestionnaireDetails.dynamicQuestionnaire.name ?? 'item'}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            event.stopPropagation();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const name = formJson.name;

            const result = await onSubmit(name);

            if (result.errorMessage) {
              enqueueSnackbar(result.errorMessage, { variant: 'error' });
            } else {
              handleClose();
            }
          },
        }}
      >
        <DialogTitle>New {dynamicQuestionnaireDetails.dynamicQuestionnaire.name ?? 'item'}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dynamicQuestionnaireDetails.dynamicQuestionnaire.description ?? ''}</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="name"
            label={(dynamicQuestionnaireDetails.dynamicQuestionnaire.name ?? 'item') + ' name'}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Add</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
